var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.3125 3.90625H4.6875C4.25603 3.90625 3.90625 4.25603 3.90625 4.6875V20.3125C3.90625 20.744 4.25603 21.0938 4.6875 21.0938H20.3125C20.744 21.0938 21.0938 20.744 21.0938 20.3125V4.6875C21.0938 4.25603 20.744 3.90625 20.3125 3.90625Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1875 2.34375V5.46875",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.8125 2.34375V5.46875",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.90625 8.59375H21.0938",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.98438 12.4995H11.7188L10.1563 14.4526C10.4132 14.4526 10.6661 14.516 10.8927 14.6371C11.1193 14.7582 11.3125 14.9333 11.4553 15.1469C11.5981 15.3605 11.686 15.606 11.7112 15.8616C11.7364 16.1173 11.6982 16.3753 11.6 16.6126C11.5018 16.85 11.3465 17.0595 11.148 17.2226C10.9494 17.3856 10.7137 17.4972 10.4618 17.5475C10.2098 17.5977 9.94937 17.585 9.70348 17.5106C9.45759 17.4362 9.23385 17.3022 9.05207 17.1207",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0625 13.6714L15.625 12.4995V17.5776",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.07adb30d1e8e21485f78f735dedaebc4.svg";
export { ForwardRef as ReactComponent };